// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ExCo","right":"Footer_right__2xRW9","buttons":"Footer_buttons__2I46t"};